/** Tipos fundamentais do motor. Sem lógica: só o vocabulário. */
export const STAT_KEYS = ['hp', 'str', 'mag', 'skl', 'spd', 'lck', 'def', 'res'];
export function samePosition(a, b) {
    return a.x === b.x && a.y === b.y;
}
/** Distância de Manhattan — a única que importa numa grade sem diagonais. */
export function distance(a, b) {
    return Math.abs(a.x - b.x) + Math.abs(a.y - b.y);
}
export function positionKey(p) {
    // Cabe qualquer mapa até 4096 de largura, e serve de chave numérica em Map,
    // que é bem mais rápida que string em laço de busca.
    return p.y * 4096 + p.x;
}
/** Quem luta contra quem. Aliado combate ao lado do jogador; neutro, com ninguém. */
export function isHostile(a, b) {
    if (a === 'neutro' || b === 'neutro')
        return false;
    const playerSide = (t) => t === 'jogador' || t === 'aliado';
    return playerSide(a) !== playerSide(b);
}
/**
 * Os tipos de arma que o motor conhece — a lista, e não só o tipo, para que os
 * editores ofereçam exatamente estes. Um editor com lista própria deixava de
 * fora metade do acervo (adaga, malho, garra, luva, besta…).
 */
export const WEAPON_TYPES = [
    'espada', 'lanca', 'machado', 'malho', 'adaga',
    'garra', 'luva', 'arco', 'besta', 'cajado', 'chicote', 'arma_de_fogo',
];
export const SINGLE_TILE = { w: 1, h: 1 };
/** A medida saneada — inteira, positiva, e o objeto único quando é uma casa. */
export function normalizeSize(size) {
    if (!size)
        return SINGLE_TILE;
    const w = Math.max(1, Math.floor(size.w));
    const h = Math.max(1, Math.floor(size.h));
    return w === 1 && h === 1 ? SINGLE_TILE : { w, h };
}
export function isSingleTile(size) {
    return normalizeSize(size) === SINGLE_TILE;
}
/** As casas que um corpo cobre, da âncora para a direita e para baixo. */
export function footprint(anchor, size) {
    const body = normalizeSize(size);
    if (body === SINGLE_TILE)
        return [anchor];
    const out = [];
    for (let dy = 0; dy < body.h; dy++) {
        for (let dx = 0; dx < body.w; dx++)
            out.push({ x: anchor.x + dx, y: anchor.y + dy });
    }
    return out;
}
/** Esta casa está debaixo do corpo ancorado ali? */
export function covers(anchor, size, p) {
    const body = normalizeSize(size);
    return (p.x >= anchor.x && p.x < anchor.x + body.w && p.y >= anchor.y && p.y < anchor.y + body.h);
}
/**
 * Distância entre dois corpos: a menor entre uma casa de um e uma casa do outro.
 *
 * É esta — e não a distância entre âncoras — que decide alcance de arma. Um
 * soldado encostado na pata de um dragão de quatro casas está a uma casa dele,
 * mesmo que a âncora do bicho esteja a três. Sem isso, o jogador não teria como
 * atacar metade de um monstro grande.
 */
export function spanDistance(a, aSize, b, bSize) {
    const A = normalizeSize(aSize);
    const B = normalizeSize(bSize);
    if (A === SINGLE_TILE && B === SINGLE_TILE)
        return distance(a, b);
    const dx = Math.max(0, a.x - (b.x + B.w - 1), b.x - (a.x + A.w - 1));
    const dy = Math.max(0, a.y - (b.y + B.h - 1), b.y - (a.y + A.h - 1));
    return dx + dy;
}
//# sourceMappingURL=types.js.map